import template from './template.html'

function contabilidadReportesexternosInventarioSucursalesComponent () {
  var $ctrl = this
  $ctrl.$onChanges = $onChanges
  $ctrl.aceptar = aceptar
  $ctrl.totalizar = totalizar

  $ctrl.editando = false

  function $onChanges (changes) {
    if (changes.data) {
      $ctrl.totalizar()
    }
  }

  function aceptar () {
    $ctrl.editando = false
    var detail = [].concat($ctrl.data)
    $ctrl.onChange({$event: {detail: detail}})
  }

  function totalizar () {

    $ctrl.total = $ctrl.data.length === $ctrl.sucursales.length
      ? 'Todos las sucursales'
      : $ctrl.data.length + ' sucursales'
  }
}

angular.module('contabilidad.reportesexternos')
  .component('contabilidadReportesexternosInventarioSucursales', {
    template,
    controller: contabilidadReportesexternosInventarioSucursalesComponent,
    bindings: {
      sucursales: '<',
      data: '<',
      onChange: '&',
    },
  })



// WEBPACK FOOTER //
// ./src/contabilidad/reportesexternos/components/inventario/sucursales/component.js